﻿require('arrive');
import moment from 'moment';
// Needed the above to use CopyOwnedCompany.cshtml

import bootbox from 'bootbox';

import { shareModalPrivateDisabledState, shareModalDisabledState, shareModalTogglePasswordState, shareModalLiveHiddenState } from './accounts';

import { inputDialog, confirmDialog, messageDialog, loadingDialog, publishDialog, alertWarning, yesNoCancelDialog, loadDataFromExcelDialog } from './dialogs';
//import { inputDialog, messageDialog, infoDialog, confirmDialog, loadingDialog } from '../common/dialogs';

import { buildAssetList, ProcessAssetUpdate, GetTutorialsList, GetCompanyList, GetReportTempaltesList, GetPeriodicAssetPrices, GetShareDailyPrice, GetShareMonthlyPrice, GetCurrencyDailyPrice, GetCurrencyMonthlyPrice } from './asset';
import { CalcCurrencyPrice, CalcCorporatePrice, CalcPortfolioPrice, submitPopupForm, selectDateRange, submitForm } from './functions';
import { convertCommentWithLinkTagToHtmlContent } from '../Corporate/hrefTagHelper';
import { GetCompanyId } from '../Corporate/company';

//console.log('Scripts/common/bindings.js file shortcut');

export function bindCommon() {
    $('.moment-replace').each(function(record) {
        var date = moment($(this).text(), "MM/DD/YYYY-HH:mm:ss");
        var dateString = "";
        if(moment().diff(date, 'years') > 10) {
            dateString = "Never";
        } else {
            dateString = date.fromNow();
        }
        $(this).text(dateString);
    });

    document.arrive('.asset-type', function() {
        GetPeriodicAssetPrices();
    });

    document.arrive('.date', function() {
        $(this).datepicker();
    });
    document.arrive('.moment-replace', function(record) {
        var date = moment($(this).text(), "MM/DD/YYYY-HH:mm:ss");
        var dateString = "";
        if(moment().diff(date, 'years') > 10) {
            dateString = "Never";
        } else {
            dateString = date.fromNow();
        }
        $(this).text(dateString);
    });

    $(".input-date").datepicker();

    $("body").on("click", "button#windows-login", function (e) {
        e.preventDefault();

        var form = $(this).closest('form');
        var provider = form.find('#Provider');

        provider.val("Windows");

        form.submit();
    });

    $("body").on("click", ".double-nav-1 li", function () {
        $(".double-nav-2 li").removeClass("active");
    });
    $("body").on("click", ".double-nav-2 li", function () {
        $(".double-nav-1 li").removeClass("active");
    });

    $("#master-body-content").on("blur", ".text-percent", function () {
        var text = $(this).val();
        if (text.search("%$") == -1) {
            $(this).val(text + "%");
        }
        if (text == "" || text == "%") {
            $(this).val("0%");
        }
    });

    $("#master-body-content").on("blur", ".text-percent-depreciation", function () {    
        var floatval = parseFloat($(this).val());
        if (isNaN(floatval)) {
            return;
        }
        
        // Below does not work...why not?
        if(floatval > 0 && floatval<100){
            $(this).val(floatval + "%");        // Only % if alternative 1, input as percentages..            
        } else if(floatval >= 100){
            $(this).val(floatval + "y");        // Only % if alternative 1, input as percentages..            
        } else {
            $(this).val(floatval);
        }

    });

    $("#master-body-content").on("blur", ".text-percent-tax", function () {    
        // Shall be possible to be an absolute number or a percentage
        var floatval = parseFloat($(this).val());
        if (isNaN(floatval)) {
            return;
        }
        if(floatval >= 0){
            $(this).val(floatval + "%");        // Only % if alternative 1, input as percentages..            
        } else {
            $(this).val(floatval);
        }
    });



    $("#master-body-content").on("blur", ".text-credit-SalesCogs", function () {    
        // Calculation needs e.g. "-100", "-200" etc... 1 period, 2 periods...
        var floatval = parseFloat($(this).val());   
        if (isNaN(floatval)) return;
        if (floatval <0) {
            floatval = 0;
        }  
        if(floatval > 0){
            if(floatval == 1){
                $(this).val(floatval + " period");
            }
            else{
                $(this).val(floatval + " periods");
            }
        }
        else{
            $(this).val(floatval);
        }        
    });




    /*  Tooltip  */
    $("body").on("hover", ".website", function (event) {
        var toolTip = $(this).attr('title');
        $('<span class="tooltip"></span>').text(toolTip)
                    .appendTo('body')
                    .css('top', (event.pageY - 10) + 'px')
                    .css('left', (event.pageX + 20) + 'px')
                    .fadeIn('slow');
    }, function () {
        $('.tooltip').remove();
    }).mousemove(function (event) {
        $('.tooltip')
                .css('top', (event.pageY - 10) + 'px')
                .css('left', (event.pageX + 20) + 'px');
    });

    $("#master-body-content").on("click", "#access-delete", function (e) {
        e.preventDefault();
        var container = $(this).closest(".admin-model");
        var url = $(this).val();
        $.ajax({
            url: url,
            method: "POST",
            data: { id: $(this).closest("form").find("input[id*='ModelAccessId']").val() },
            success: function (data) {
                container.html(data);
            }
        });
    });

    // The below works wrt saving 'Portfolio', BUT it does not work wrt saving the 'Corporate'...why not?
    $("#master-body-content").on("click", "#access-save", function (e) {
        e.preventDefault();

        //alert("access-save")

        var container = $(this).closest(".admin-model");
         var form = $(this).closest("form");      // Old
        
        submitForm(form, function (data) {
            container.html(data);
        });
    });


    $("#master-body-content").on("click", "#corporate-access-save", function (e) {
        e.preventDefault();
        var container = $(this).closest(".admin-model");
        var form = $(this).closest("form");      // Old
        //var form = $(this).parent();
        //submitForm(form, function (data) {
        //    container.html(data);
        //});

        var url = $(this).val();
        $.ajax({
            url: url,
            method: "POST",
            //data: { id: $(this).closest("form").find("input[id*='ModelAccessId']").val() },
            success: function (data) {
                container.html(data);
            }
        });

    });
    $("#master-body-content").on("change", "#access-model-list", function () {
        var id = $(this).val();
        var container = $(this).closest(".admin-model");
        $.ajax({
            url: container.find(".access-model-url").val(),
            method: "GET",
            data: { id: id },
            success: function (data) {
                container.html(data);
            }
        });
    });

    // Home tab: The changing images
    $('.fadein img:gt(0)').hide();
    setInterval(function () { $('.fadein img:first-child').fadeOut(2000).next('img').fadeIn(2000).end().appendTo('.fadein'); }, 6000);

    // Solutions Tab: Shifting/clicking between the different solutions
    $("#lblCorporate").click(function (event) {
        $('#lblCorporate').css({ 'color': '#000000', 'font-style': 'normal' });
        $('#lblPortfolio').css({ 'color': '#000000', 'font-style': 'normal' });
        $('#lblCurrency').css({ 'color': '#000000', 'font-style': 'normal' });
        $('#lblAccess').css({ 'color': '#000000', 'font-style': 'normal' });
        $('#lblPrices').css({ 'color': '#000000', 'font-style': 'normal' });

        $(this).css({ 'color': '#000000', 'font-style': 'italic' });

        if ($("#solutions-explanations-corporate").is(":hidden")) {
            $("#solutions-explanations-portfolio").hide()
            $("#solutions-explanations-currency").hide()
            $("#solutions-explanations-access").hide()
            $("#solutions-explanations-prices").hide()
            $("#solutions-explanations-corporate").slideToggle(0);
        }
    });

    $("#lblPortfolio").click(function (event) {
        $('#lblCorporate').css({ 'color': '#000000', 'font-style': 'normal' });
        $('#lblPortfolio').css({ 'color': '#000000', 'font-style': 'normal' });
        $('#lblCurrency').css({ 'color': '#000000', 'font-style': 'normal' });
        $('#lblAccess').css({ 'color': '#000000', 'font-style': 'normal' });
        $('#lblPrices').css({ 'color': '#000000', 'font-style': 'normal' });
        $(this).css({ 'color': '#000000', 'font-style': 'italic' });

        if ($("#solutions-explanations-portfolio").is(":hidden")) {
            $("#solutions-explanations-corporate").hide()
            $("#solutions-explanations-currency").hide()
            $("#solutions-explanations-access").hide()
            $("#solutions-explanations-prices").hide()
            $("#solutions-explanations-portfolio").slideToggle(0);
        }
    });

    $("#lblCurrency").click(function (event) {
        $('#lblCorporate').css({ 'color': '#000000', 'font-style': 'normal' });
        $('#lblPortfolio').css({ 'color': '#000000', 'font-style': 'normal' });
        $('#lblCurrency').css({ 'color': '#000000', 'font-style': 'normal' });
        $('#lblAccess').css({ 'color': '#000000', 'font-style': 'normal' });
        $('#lblPrices').css({ 'color': '#000000', 'font-style': 'normal' });
        $(this).css({ 'color': '#000000', 'font-style': 'italic' });

        if ($("#solutions-explanations-currency").is(":hidden")) {
            $("#solutions-explanations-corporate").hide()
            $("#solutions-explanations-portfolio").hide()
            $("#solutions-explanations-access").hide()
            $("#solutions-explanations-prices").hide()
            $("#solutions-explanations-currency").slideToggle(0);
        }
    });

    $("#lblAccess").click(function (event) {
        $('#lblCorporate').css({ 'color': '#000000', 'font-style': 'normal' });
        $('#lblPortfolio').css({ 'color': '#000000', 'font-style': 'normal' });
        $('#lblCurrency').css({ 'color': '#000000', 'font-style': 'normal' });
        $('#lblAccess').css({ 'color': '#000000', 'font-style': 'normal' });
        $('#lblPrices').css({ 'color': '#000000', 'font-style': 'normal' });
        $(this).css({ 'color': '#000000', 'font-style': 'italic' });

        if ($("#solutions-explanations-access").is(":hidden")) {
            $("#divAccessSub").hide()
            $("#solutions-explanations-corporate").hide()
            $("#solutions-explanations-portfolio").hide()
            $("#solutions-explanations-currency").hide()
            $("#solutions-explanations-prices").hide()
            $("#solutions-explanations-access").slideToggle(0);
        }
    });

    $("#lbldivAccessSub").click(function (event) {
        $('#divAccessSub').slideToggle(1000);
    });

    $("#lblPrices").click(function (event) {
        $('#lblCorporate').css({ 'color': '#000000', 'font-style': 'normal' });
        $('#lblPortfolio').css({ 'color': '#000000', 'font-style': 'normal' });
        $('#lblCurrency').css({ 'color': '#000000', 'font-style': 'normal' });
        $('#lblAccess').css({ 'color': '#000000', 'font-style': 'normal' });
        $('#lblPrices').css({ 'color': '#000000', 'font-style': 'normal' });
        $(this).css({ 'color': '#000000', 'font-style': 'italic' });

        if ($("#solutions-explanations-prices").is(":hidden")) {
            $("#solutions-explanations-prices-corporate").hide()
            $("#solutions-explanations-prices-portfolio").hide()
            $("#solutions-explanations-prices-currency").hide()

            $("#solutions-explanations-corporate").hide()
            $("#solutions-explanations-portfolio").hide()
            $("#solutions-explanations-currency").hide()
            $("#solutions-explanations-access").hide()
            $("#solutions-explanations-prices").slideToggle(0);
        }
    });

    // Calculate prices.....Corporate
    $(".PricingDDL").change(function (event) {
        CalcCorporatePrice()
    });

    // Calculate prices.....Portfolio                                                       NB! THESE CAN BE REMOVED....IF USER CANNOT CHOOSE nShares, nFX, nPortfolios..
    $("#solution-portfolio-portfolios").change(function (event) {
        CalcPortfolioPrice()
    });
    $("#solution-portfolio-licenses").change(function (event) {
        CalcPortfolioPrice()
    });

    // Calculate prices.....Currency
    $("#solution-currency-portfolios").change(function (event) {
        CalcCurrencyPrice()
    });
    $("#solution-currency-licenses").change(function (event) {
        CalcCurrencyPrice()
    });

    // Tutorials Tab: Shifting/clicking between the different solutions
    $("#Tutorials_lblCorporate").click(function (event) {
        $('#Tutorials_lblCorporate').css({ 'color': '#000000', 'font-style': 'normal' });
        $('#Tutorials_lblPortfolio').css({ 'color': '#000000', 'font-style': 'normal' });
        $('#Tutorials_lblCurrency').css({ 'color': '#000000', 'font-style': 'normal' });
        $(this).css({ 'color': '#000000', 'font-style': 'italic' });
        if ($("#Tutorials_DivCorporate").is(":hidden")) {
            $("#Tutorials_DivPortfolio").hide()
            $("#Tutorials_DivCurrency").hide()
            $("#Tutorials_DivCorporate").slideToggle(0);
        }
    });

    $("#Tutorials_lblPortfolio").click(function (event) {
        $('#Tutorials_lblCorporate').css({ 'color': '#000000', 'font-style': 'normal' });
        $('#Tutorials_lblPortfolio').css({ 'color': '#000000', 'font-style': 'normal' });
        $('#Tutorials_lblCurrency').css({ 'color': '#000000', 'font-style': 'normal' });
        $(this).css({ 'color': '#000000', 'font-style': 'italic' });
        if ($("#Tutorials_DivPortfolio").is(":hidden")) {
            $("#Tutorials_DivCorporate").hide()
            $("#Tutorials_DivCurrency").hide()
            $("#Tutorials_DivPortfolio").slideToggle(0);
        }
    });

    $("#Tutorials_lblCurrency").click(function (event) {
        $('#Tutorials_lblCorporate').css({ 'color': '#000000', 'font-style': 'normal' });
        $('#Tutorials_lblPortfolio').css({ 'color': '#000000', 'font-style': 'normal' });
        $('#Tutorials_lblCurrency').css({ 'color': '#000000', 'font-style': 'normal' });
        $(this).css({ 'color': '#000000', 'font-style': 'italic' });
        if ($("#Tutorials_DivCurrency").is(":hidden")) {
            $("#Tutorials_DivCorporate").hide()
            $("#Tutorials_DivPortfolio").hide()
            $("#Tutorials_DivCurrency").slideToggle(0);
        }
    });

    // Accounts bindings for OnlinePartnerAdminPanel view
    $("#master-body-content").on("change", "#online-partner-admin-users-id", function () {
        $.ajax({
            url: Router.action("UserAccess", "OnlinePartnerAdminPanel"),
            method: "GET",
            data: { Id: $(this).val() },
            success: function (data) {
                $("#master-body-content").html(data);
            }
        });
    });

    // Accounts bindings
    $("#master-body-content").on("change", "#admin-users-id", function () {
        $.ajax({
            url: Router.action("UserAccess", "AdminUsers"),
            method: "GET",
            data: { Id: $(this).val() },
            success: function (data) {
                $("#master-body-content").html(data);
            }
        });
    });
    $("#master-body-content").on("click", "#admin-users-submit", function (e) {
        e.preventDefault();
        submitForm($(this).closest("form"), function (data) {
            $("#master-body-content").html(data);
        });
    });
    $("#master-body-content").on("click", "#admin-users-delete", function (e) {
        e.preventDefault();

        var id = $("#admin-users-id").val();

        if (id != 0) {
            confirmDialog("Confirm Delete", "Are you sure you want to delete this User? Really, really sure?", function (result) {
                if (result) {
                    $.ajax({
                        url: Router.action("UserAccess", "DeleteUser"),
                        method: "POST",
                        data: { UserId: id },
                        success: function (data) {
                            $("#master-body-content").html(data);
                        },
                        error: function () {
                            alertWarning("Failed to delete user");
                        }
                    });
                }
            });
        }
    });

    $("body").on("change", "#template-selection", function () {
        $("#template-selection-warning").hide();
        var TemplateHelpText = $("#template-selection").find(":selected").data("content");
        var sanitizedComment = convertCommentWithLinkTagToHtmlContent(TemplateHelpText);
        $("#template-help-text").html(sanitizedComment);
    });

    $("body").on("change", "td input.liveshare-confirmed", function (e) {
        var confirmed = $(this).is(':checked');
        var id = $(this).closest("tr").find(".liveshare-id").val();

        $.ajax({
            url: Router.action("Portfolio", "UserSharingConfirm", { area: "Corp" }),
            method: "POST",
            data: { id: id, confirmed: confirmed },
            success: function () {
                $.ajax({
                    url: Router.action("UserAccess", "UserSharing"),
                    method: "GET",
                    success: function (data2) {
                        $("#master-body-content").html(data2);
                    }
                });
            }
        });       
    });

    // Coped from above and adjusted.
    $("body").on("change", "input.share-accepted", function (e) {
        var Confirmed = $(this).is(':checked');
        var ReportTemplateId = $(this).closest("tr").find(".report-template-id").val();

        $.ajax({
            url: Router.action("Portfolio", "UserSharingReportTemplateConfirm", { area: "Corp" }),
            method: "POST",
            data: { ReportTemplateId: ReportTemplateId, Confirmed: Confirmed },
            success: function () {
                $.ajax({
                    url: Router.action("UserAccess", "ManageTemplates"),
                    method: "GET",
                    success: function (data2) {
                        $("#master-body-content").html(data2);
                    }
                });
            }
        });       
    });

    // Functionality for model limitation admin
    $("#master-body-content").on("click", ".models-add-model", function (e) {
        e.preventDefault();
        var Type = parseInt($(this).val());
        if (Type < -3 || Type > -1) alert("Feil!");

        $.ajax({
            url: Router.action("User", "Models"),
            method: "GET",
            data: { Id: Type },
            success: function (data) {
                $("#master-body-content").html(data);
            }
        });

        /*
        var listElement = $("<li class='model-limits-element active' />");
        listElement.append("<input type='hidden' value='-1' />");
        listElement.append("<a href='#'>New model</a>");
        $("#models-list").append(listElement);
        $("[name$='ModelLimitationId']").val(0);
        $("[name$='ModelName']").val("New model");
        */
    });
    $("#master-body-content").on("click", "#models-list a", function (e) {
        e.preventDefault();
        var Id = $(this).parent().find("input").val();
        $.ajax({
            url: Router.action("User", "Models"),
            method: "GET",
            data: { Id: Id },
            success: function (data) {
                $("#master-body-content").html(data);
            }
        });
    });
    $("#master-body-content").on("click", "#models-save-button", function (e) {
        e.preventDefault();
        var form = $(this).parent();
        submitForm(form, function (data) {
            $("#master-body-content").html(data);
        });
    });

    // User Front Page
    $("#master-body-content").on("change", ".subscription-", function () {
        var form = $(this).parent();
        var url = form.attr("action");
        var div = $(this).parent().parent();
        $.ajax({
            url: Router.action("Home", "PortfolioSubscription"), //form.attr("action"),
            data: { Id: $(this).val() },
            method: "GET",
            success: function (data) {
                div.html(data);
            }
        });
    });
    $("#master-body-content").on("change", ".subscription-model-id", function () {
        var form = $(this).parent();
        var url = form.attr("action");
        var div = $(this).parent().parent();
        $.ajax({
            url: Router.action("Home", "PortfolioSubscription"), //form.attr("action"),
            data: { Id: $(this).val() },
            method: "GET",
            success: function (data) {
                div.html(data);
            }
        });
    });

    $("#master-body-content").on("click", ".share-company-line .share-company-get-uri", function () {
        var uri = $(this).closest("td").find(".share-company-uri").val();
        messageDialog("Copy url", "<input class='form-control' type='text' readonly value='" + uri + "' />");
    });

    $("#master-body-content").on("click", ".share-company-line .share-company-settings", function () {
       
        // This ".share-company-settings" code is called when clicked sharing on the UserSharing table  
        // That is, calls another ".share-company-settings" than when click sharing from inside the Corporate Model 
        // ... this code is within: 'common\bindings.js'
        // ... the other code within: 'corporate\bindings.js' 
        
        // alert("Sharing from the UserSharing")

        var parent = $(this).closest("tr");
        var id = parent.find(".share-company-id").val();
        var name = parent.find(".share-company-name").text();           // 
       
        $.ajax({
            url: Router.action("Portfolio", "ShareCompanySettings", { area: "Corp" }), //form.attr("action"),
            data: { id: id },
            method: "GET",
            success: function (data) {
                bootbox.dialog({
                    //title: name + ": Sharing Settings",
                    title: name,
                    message: (function (returnData, callback) {
                        var dataDiv = $('<div style="display: block;" />')
                        dataDiv.append(returnData);

                        callback(dataDiv);
                        return dataDiv.html();
                    })(data, function (dataDiv) {
                        dataDiv.find(".moment-replace").each(function () {
                            var date = moment.utc($(this).text(), "MM/DD/YYYY-HH:mm:ss");
                            var dateString = "";
                            if (moment().diff(date, 'years') > 10) {
                                dateString = "Never";
                            } else {
                                dateString = date.fromNow();
                            }
                            $(this).text(dateString);
                        });
                        $('[data-toggle="popover"]').popover()
                        shareModalDisabledState($(".modal-dialog #is-shared").val() === 'True');
                        shareModalPrivateDisabledState($(".modal-dialog select[name='UserSettings.Id']").val(), $('#UserSettings_ShareActive').val() === 'True');
                        shareModalLiveHiddenState($(".modal-dialog select[name='UserSettings.LiveShare']").val() === 'True');
                        shareModalTogglePasswordState();

                        //$('#UserSettings_Email').focus();

                    }),
                    //className: "wide-modal",
                    className: "wide-modal-800",
                    buttons: {
                        Save: {
                            label: "Update",
                            className: "btn btn-primary",
                            callback: function (e) {
                                var target = e.target || e.srcElement;
                                var parent = $(target).closest(".modal-dialog");
                                var form = parent.find("form");
                                submitPopupForm(form, function (data) {
                                    $("#jubbajubb").replaceWith(data);
                                    $(".modal-dialog .moment-replace").each(function () {
                                        var date = moment.utc($(this).text(), "MM/DD/YYYY-HH:mm:ss");
                                        var dateString = "";
                                        if (moment().diff(date, 'years') > 10) {
                                            dateString = "Never";
                                        } else {
                                            dateString = date.fromNow();
                                        }
                                        $(this).text(dateString);
                                    });
                                    $('[data-toggle="popover"]').popover()
                                    shareModalDisabledState($(".modal-dialog #is-shared").val() === 'True');
                                    shareModalPrivateDisabledState($(".modal-dialog select[name='UserSettings.Id']").val(), $('#UserSettings_ShareActive').val() === 'True');
                                    shareModalLiveHiddenState($(".modal-dialog select[name='UserSettings.LiveShare']").val() === 'True');
                                    shareModalTogglePasswordState();
                                    $.ajax({
                                        url: Router.action("UserAccess", "UserSharing"),
                                        method: "GET",
                                        success: function (data2) {
                                            $("#master-body-content").html(data2);
                                        }
                                    });
                                });
                                return false;
                            }
                        },
                        Close: {
                            label: "Close",
                            className: "btn btn-default",
                            callback: function (e) {
                            }
                        }
                    }
                }).init(function() {
                    $(".modal-dialog .moment-replace").each(function () {
                        var date = moment.utc($(this).text(), "MM/DD/YYYY-HH:mm:ss");
                        var dateString = "";
                        if (moment().diff(date, 'years') > 10) {
                            dateString = "Never";
                        } else {
                            dateString = date.fromNow();
                        }
                        $(this).text(dateString);
                    });
                    $('[data-toggle="popover"]').popover()
                    shareModalDisabledState($(".modal-dialog #is-shared").val() === 'True');
                    shareModalPrivateDisabledState($(".modal-dialog select[name='UserSettings.Id']").val(), $('#UserSettings_ShareActive').val() === 'True');
                    shareModalLiveHiddenState($(".modal-dialog select[name='UserSettings.LiveShare']").val() === 'True');
                    shareModalTogglePasswordState();
                });
            }
        });
    });

    // Sharing report template from manage templates screen.
    $("#master-body-content").on("click", ".share-report-template", function () {

        // Find id and name of the report template.
        var parent = $(this).closest("tr");
        var ReportTemplateId = parent.find(".report-template-id").val();
        var name = parent.find(".report-template-name").text();

        // Determine which sharing icon is shown currently.
        var SharingIcon = parent.find(".material-icons").eq(0).text()

        // Copied and adjusted code.
        $.ajax({
            url: Router.action("Portfolio", "ShareReportTemplateSettings", { area: "Corp" }),
            data: { ReportTemplateId: ReportTemplateId },
            method: "GET",
            success: function (data) {
                bootbox.dialog({
                    title: name,
                    message: (function (returnData, callback) {
                        var dataDiv = $('<div style="display: block;" />')
                        dataDiv.append(returnData);

                        callback(dataDiv);
                        return dataDiv.html();
                    })(data, function (dataDiv) {
                        dataDiv.find(".moment-replace").each(function () {
                            var date = moment.utc($(this).text(), "MM/DD/YYYY-HH:mm:ss");
                            var dateString = "";
                            if (moment().diff(date, 'years') > 10) {
                                dateString = "Never";
                            } else {
                                dateString = date.fromNow();
                            }
                            $(this).text(dateString);
                        });
                        $('[data-toggle="popover"]').popover()
                        shareModalDisabledState($(".modal-dialog #is-shared").val() === 'True');
                        shareModalPrivateDisabledState($(".modal-dialog select[name='UserSettings.Id']").val(), $('#UserSettings_ShareActive').val() === 'True');
                        shareModalLiveHiddenState($(".modal-dialog select[name='UserSettings.LiveShare']").val() === 'True');
                        shareModalTogglePasswordState();
                    }),
                    className: "wide-modal-800",
                    buttons: {
                        Save: {
                            label: "Save",
                            className: "btn btn-primary",
                            callback: function (e) {
                                var target = e.target || e.srcElement;
                                var parent = $(target).closest(".modal-dialog");
                                var form = parent.find("form");
                                submitPopupForm(form, function (data) {
                                    $("#jubbajubb").replaceWith(data);
                                    $(".modal-dialog .moment-replace").each(function () {
                                        var date = moment.utc($(this).text(), "MM/DD/YYYY-HH:mm:ss");
                                        var dateString = "";
                                        if (moment().diff(date, 'years') > 10) {
                                            dateString = "Never";
                                        } else {
                                            dateString = date.fromNow();
                                        }
                                        $(this).text(dateString);
                                    });
                                    $('[data-toggle="popover"]').popover()
                                    shareModalDisabledState($(".modal-dialog #is-shared").val() === 'True');
                                    shareModalPrivateDisabledState($(".modal-dialog select[name='UserSettings.Id']").val(), $('#UserSettings_ShareActive').val() === 'True');
                                    shareModalLiveHiddenState($(".modal-dialog select[name='UserSettings.LiveShare']").val() === 'True');
                                    shareModalTogglePasswordState();
 
                                    // If Save button is pressed without selected anything.
                                    if ($('#UserSettings_UserShareReportTemplateId').val() === "0") {
                                        // Hide e-mail part.
                                        $('.private-share-user-selected').hide();
                                        // Hide "Remove user" button place.
                                        $('.private-share-disable').hide();
                                    }
                                    else {
                                        // Show "Remove user" button.
                                        $('.private-share-disable').css("visibility", "visible");
                                    }

                                    $.ajax({
                                        url: Router.action("UserAccess", "ManageTemplates"),
                                        method: "GET",
                                        success: function (data2) {
                                            $("#master-body-content").html(data2);
                                        }
                                    });
                                });
                                return false;
                            }
                        },
                        Close: {
                            label: "Close",
                            className: "btn btn-default",
                            callback: function (e) {
                            }
                        }
                    }
                }).init(function() {
                    $(".modal-dialog .moment-replace").each(function () {
                        var date = moment.utc($(this).text(), "MM/DD/YYYY-HH:mm:ss");
                        var dateString = "";
                        if (moment().diff(date, 'years') > 10) {
                            dateString = "Never";
                        } else {
                            dateString = date.fromNow();
                        }
                        $(this).text(dateString);
                    });
                    $('[data-toggle="popover"]').popover()
                    shareModalDisabledState($(".modal-dialog #is-shared").val() === 'True');
                    shareModalPrivateDisabledState($(".modal-dialog select[name='UserSettings.Id']").val(), $('#UserSettings_ShareActive').val() === 'True');
                    shareModalLiveHiddenState($(".modal-dialog select[name='UserSettings.LiveShare']").val() === 'True');
                    shareModalTogglePasswordState();

                    // If report template is not shared then preselect "Select" in drop-down list and hide e-mail part and remove button.
                    if (SharingIcon === "share") {
                        // Select "New" from the drop-down list.
                        $("#UserSettings_UserShareReportTemplateId").val('-1');

                        // Hide "Remove user" button.
                        $('.private-share-disable').hide();
                    }

                    // If report template is shared already then preselect "Select" in drop-down list, show e-mail part and hide remove button.
                    if (SharingIcon === "group_add") {
                        // Select "Select" from the drop-down list.
                        $("#UserSettings_UserShareReportTemplateId").val('0');

                        // Hide e-mail part.
                        $('.private-share-user-selected').hide();

                        // Hide "Remove user" button.
                        $('.private-share-disable').hide();
                    }
                });
            }
        });

    });

    // Delete button/can on the Dashboard....separate Delete code on the old delete code on the other bidings.js
    //$("body").on("click", ".DeleteCompany_DashBoard", function () {
    $("#master-body-content").on("click", ".share-company-line .DeleteCompany_DashBoard", function () {
        // PS! There is also a check on the actual delete code, e.g. cannot delete a Company that belong to someone else :  public JsonResult DeleteCurrentCompany()
        //var SelectCompanyIndex = $("#SelectCompany").val();        
        var parent = $(this).closest("tr");
        var id = parent.find(".share-company-id").val();
        var name = parent.find(".share-company-name").text();           // 
        
        //if (SelectCompanyIndex != "") {
        confirmDialog("Confirm Delete", "Are you sure you want to delete " + name +"?", function (result) {
            
            if (result) {
                
                $.ajax({
                    url: Router.action("Portfolio", "DeleteCurrentCompany_DashBoard", { area: "Corp" }),
                    method: "POST",
                    //data: { CompanyId: GetCompanyId(), EntityId: GetEntityId() },
                    data: { id: id },

                    success: function () {
                        // Trying to reload the Model ss as to fill the Company ddl with the remaining Companies: Try to copy code from CompanyCreate
                        //$("#SelectCompany").prop("selectedIndex", 0);   /* reset to choose..*/
                        //SetEntityId(0);
                        //UpdateCompanyList(0);
                        //$("#corp-input-area").html("");

                        $.ajax({
                            url: Router.action("UserAccess", "UserSharing"),
                            method: "GET",
                            success: function (data2) {
                                $("#master-body-content").html(data2);
                            }
                        });

                    }
                });
                     

            }

            // Removing the separator after the deleted item.
            //$("#select-company li[value=" + SelectCompanyIndex + "]").next().remove();

            // Deleting the item.
            //$("#select-company li[value=" + SelectCompanyIndex + "]").remove();

            // Refresh the page?

        });
        //}
        //else {
        //    messageDialog("Delete", "You must select a company to delete. ", 200, 300);
        //}             
    });

    $("#master-body-content").on("click", "#DeleteReportTemplate", function () {

        // Find id and name of the report template.
        var parent = $(this).closest("tr");
        var ReportTemplateId = parent.find(".report-template-id").val();
        var name = parent.find(".report-template-name").text();

        confirmDialog("Confirm delete report template", "Are you sure you want to delete report template " + name +"?", function (result) {
            if (result) {
                $.ajax({
                    url: Router.action("Portfolio", "DeleteReportTemplate", { area: "Corp" }),
                    method: "POST",
                    data: { ReportTemplateId: ReportTemplateId },
                    success: function () {
                        // After deleting refresh the page.
                        $.ajax({
                            url: Router.action("UserAccess", "ManageTemplates"),
                            method: "GET",
                            success: function (data2) {
                                $("#master-body-content").html(data2);
                            }
                        });
                    }
                });
            }
        });
    });

    $("body").on("change", ".modal-dialog #is-shared", function () {
        shareModalDisabledState($(this).val() === 'True');
    });

    $("body").on("change", ".modal-dialog #UserSettings_LiveShare", function () {
        shareModalLiveHiddenState($(this).val() === 'True');
    });

    $("body").on("change", ".modal-dialog #NeedsPassword, .modal-dialog #UserSettings_NeedsPassword", function () {
        shareModalTogglePasswordState();
    });

    $("body").on("change", "select[name='UserSettings.Id']", function () {
        var id = $("#Id").val();
        var userId = $(this).val();
        var url = Router.action("Portfolio", "UserSharingSettings", { area: "Corp" });

        $.ajax({
            url: url,
            method: "GET",
            data: { id: id, userId: userId },
            success: function (json) {
                $("#UserSettings_Email").val(json.Email);
                //$("#UserSettings_Id").val(json.Id);
                $("#UserSettings_LiveShare").val(json.LiveShare ? "True" : "False");
                $("#UserSettings_NeedsPassword").val(json.NeedsPassword ? "True" : "False");

                $("#UserSettings_ShareActive").val(json.ShareActive ? "True" : "False");
                $("#UserSettings_LiveShareCanCopy").val(json.LiveShareCanCopy ? "True" : "False");

                $("#UserSettings_ContinuousUpdate").val(json.ContinuousUpdate ? "True" : "False");

                $("#UserSettings_LiveShareReadOnly").val(json.LiveShareReadOnly ? "True" : "False");


                $("#UserSettings_Password").val(json.Password);

                shareModalLiveHiddenState(json.LiveShare);
                shareModalPrivateDisabledState(json.Id, json.ShareActive);
                shareModalTogglePasswordState();
            }
        });
    });

    // Copied from above and adjusted
    // Switching user shared e-mail in a pop-up window.
    $("body").on("change", "select[name='UserSettings.UserShareReportTemplateId']", function () {
        
        var id = $("#Id").val();            // Report template id. Maybe change name "id" later.
        var userId = $(this).val();         // UserShareReportTemplateId. Maybe change name "userId" later.

        $.ajax({
            url: Router.action("Portfolio", "UserReportTemplatesSharingSettings", { area: "Corp" }),
            method: "GET",
            data: { id: id, userId: userId },
            success: function (json) {
                $("#UserSettings_Email").val(json.Email);

                //$("#UserSettings_LiveShare").val(json.LiveShare ? "True" : "False");
                //$("#UserSettings_NeedsPassword").val(json.NeedsPassword ? "True" : "False");
                //$("#UserSettings_ShareActive").val(json.ShareActive ? "True" : "False");
                //$("#UserSettings_LiveShareCanCopy").val(json.LiveShareCanCopy ? "True" : "False");
                //$("#UserSettings_ContinuousUpdate").val(json.ContinuousUpdate ? "True" : "False");
                //$("#UserSettings_LiveShareReadOnly").val(json.LiveShareReadOnly ? "True" : "False");
                //$("#UserSettings_Password").val(json.Password);

                //shareModalLiveHiddenState(json.LiveShare);
                shareModalLiveHiddenState("True");
                shareModalPrivateDisabledState(json.Id, json.ShareActive);
                shareModalTogglePasswordState();

                // "private-share-user-selected" is a class for managing e-mail elements.
                // "private-share-disable" is a class for managing "Remove user" button.

                // If "Select" is selected from drop-down menu.
                if (userId === "0") {
                    $('.private-share-user-selected').hide();
                    $('.private-share-disable').hide();
                }
                // If "New" is selected from drop-down menu.
                else if (userId === "-1"){
                    $('.private-share-user-selected').show();
                    $('.private-share-disable').hide();
                }
                // If user e-mail is selected from drop-down menu.
                else {
                    $('.private-share-user-selected').show();
                    $('.private-share-disable').show();
                    $('.private-share-disable').css('visibility', 'visible');
                }
            }
        });
    });

    $("body").on("change", "#UserSettings_ShareActive", function () {
        shareModalPrivateDisabledState($('#UserSettings_Id').val(), $(this).val() === 'True');
    });

    $("body").on("click", "#private-sharing-delete-user", function () {
        var id = $("#Id").val();
        var userId = $(".modal-dialog select[name='UserSettings.Id']").val();
        var url = Router.action("Portfolio", "UserSharingDelete", { area: "Corp" });
        var urlTWO = Router.action("Portfolio", "ShareCompanySettings", { area: "Corp" });

        $.ajax({
            url: url,
            method: "POST",
            data: { id: id, userId: userId },
            success: function (json) {
                $("#UserSettings_Id option[value='" + userId + "']").remove();
                $("#UserSettings_Id").val("0");
                $("#UserSettings_Email").val("");
                $("#UserSettings_LiveShare").val("False");

                shareModalLiveHiddenState(false);
                shareModalPrivateDisabledState(0, false);

                $("#UserSettings_ShareActive").val('False');
                $("#UserSettings_LiveShareCanCopy").val('False');
                $("#UserSettings_NeedsPassword").val('False');
                $("#UserSettings_Password").val("");

                // reload the pop-up, to get the new info updated .. does not work
                //$.ajax({
                //    url: urlTWO,
                //    method: "POST",
                //    success: function (data2) {
                //        $("#master-body-content").html(data2);
                //    }
                //});

                // alt. idea: Close the popup? ...does not work
                //var daddy = window.self;
                //daddy.opener = window.self;
                //daddy.close();
            }
        });
    });

    // Copied from above and adjusted.
    $("body").on("click", "#sharing-report-template-delete-user", function () {

        // Get id of report template.
        var ReportTemplateId = $("#Id").val();

        // Get id of sharing (TemplateReportUserSharingSetups table).
        var userId = $(".modal-dialog select[name='UserSettings.UserShareReportTemplateId']").val();

        $.ajax({
            url: Router.action("Portfolio", "UnshareReportTemplate", { area: "Corp" }),
            method: "POST",
            data: { ReportTemplateId: ReportTemplateId, userId: userId },
            success: function () {

                // Remove unshared user's e-mail from drop-down list.
                $("#UserSettings_UserShareReportTemplateId option[value='" + userId + "']").remove();

                // Set drop-down selection to "Select".
                $("#UserSettings_UserShareReportTemplateId").val("0");

                // Hide e-mail part.
                $(".private-share-user-selected").hide();

                // Hide "Remove user" button.
                $(".private-share-disable").hide();
    
                // Old code. Maybe not needed anymore.
                shareModalLiveHiddenState(false);
                shareModalPrivateDisabledState(0, false);

                $.ajax({
                    url: Router.action("UserAccess", "ManageTemplates"),
                    method: "GET",
                    success: function (data2) {
                        $("#master-body-content").html(data2);
                    }
                });

            }
        });
    });

    $("body").on("click", "#update-snapshot", function (e) {
        e.preventDefault();

        //var target = e.target || e.srcElement;
        var target = e.target;

        var parent = $(target).closest(".share-company-line");
        var Id = parent.find(".share-company-id").val();

        $.ajax({
            url: Router.action("Portfolio", "UpdateCompanySnapshot", { area: "Corp" }), //form.attr("action"),
            method: "POST",
            data: { Id: Id },
            success: function (updated) {
                setTimeout(function () {
                    var date = moment.utc(updated);
                    var dateString = "";
                    if (moment().diff(date, 'years') > 10) {
                        dateString = "Never";
                    } else {
                        dateString = date.fromNow();
                    }
                    $(".snapshot-updated").text(dateString);
                }, 1000);

                $.ajax({
                    url: Router.action("UserAccess", "UserSharing"),
                    method: "GET",
                    success: function (data2) {
                        $("#master-body-content").html(data2);
                    }
                });
            }
        });
        return false;
    });


    $("body").on("click", ".CopyOwnedCompany", function (e) {
        e.preventDefault();

        //var target = e.target || e.srcElement;
        var target = e.target;
        var parent = $(target).closest(".share-company-line");
        var Id = parent.find(".share-company-id").val();

        $.ajax({
            url: Router.action("Portfolio", "UpdateCompanySnapshot", { area: "Corp" }),
            method: "POST",
            data: { Id: Id },
            success: function (updated) {
                setTimeout(function () {
                    var date = moment.utc(updated);
                    var dateString = "";
                    if (moment().diff(date, 'years') > 10) {
                        dateString = "Never";
                    } else {
                        dateString = date.fromNow();
                    }
                    $(".snapshot-updated").text(dateString);
                }, 1000);

                $.ajax({
                    url: Router.action("Portfolio", "CopyOwnedCompany", { area: "Corp" }),
                    data: { id: Id },
                    method: "GET",
                    success: function (data2) {
                        $("#master-body-content").html(data2);
                    }                    
                });
            }
        });

        return false;
    });

    $("body").on("click", "#add-members-to-group", function () {
        var groupId = $(this).data("content");
        var dialogContent = '\
            <div class="row"> \
                <div> \
                    <label class="col-md-12">List of user emails to invite (one email per line)</label>\
                </div>\
            </div>\
            \
            <div class="row mt-4">\
                <div style="margin-left: -15px; padding-left: 30px; padding-right: 30px">\
                    <textarea id="emails-list" class="form-control" style="height: 15rem;"></textarea>\
                </div>\
            </div>';


        bootbox.dialog({
            title: "Add members",
            message: dialogContent,
            buttons: {
                Add: {
                    label: "Add",
                    className: "btn-default",
                    callback: function (e) {
                        var emailsList = $("#emails-list").val();
                        $.ajax({
                            url: Router.action("OnlinePartner", "AddMembersToGroup"),
                            method: "POST",
                            data: { EmailsString: emailsList, GroupId: groupId },
                            success: function (response) {
                                if (response && response.Result && response.Result === "OK") {
                                    location.reload();
                                } else {
                                    alertWarning("Failed to add members. Please type in correct email addresses (one per line)");
                                }
                            },
                            error: function () {
                                alertWarning("Failed to add members. Please type in correct email addresses (one per line)");
                            }
                        });
                    }
                },
                Cancel: {
                    label: "Cancel",
                    className: "btn-default",
                    callback: function () {
                    }
                }
            }
        });
    });

    $("body").on("click", "a[data-bind=\"remove-member-from-group\"]", function (e) {
        e.preventDefault();
        var parentElement = $(this).parent();
        var memberGroupId = parentElement.data("container");
        var memberEmail = parentElement.data("content");

        $.ajax({
            url: Router.action("OnlinePartner", "RemoveMemberFromGroup"),
            method: "DELETE",
            data: { GroupId: memberGroupId, Email: memberEmail },
            success: function (response) {
                if (response && response.Result && response.Result === "OK") {
                    location.reload();
                } else {
                    alertWarning("Failed to remove member! Refresh page and then try again");
                }
            },
            error: function () {
                alertWarning("Failed to remove member! Refresh page and then try again");
            }
        });
    });

    $("body").on("click", "a[data-bind=\"reinvite-member\"]", function (e) {
        e.preventDefault();
        var parentElement = $(this).parent();
        var memberGroupId = parentElement.data("container");
        var memberEmail = parentElement.data("content");

        $.ajax({
            url: Router.action("OnlinePartner", "ReinviteMember"),
            method: "PUT",
            data: { GroupId: memberGroupId, Email: memberEmail },
            success: function (response) {
                if (response && response.Result && response.Result === "OK") {
                    location.reload();
                } else {
                    alertWarning("Failed to invite member! Refresh page and then try again");
                }
            },
            error: function () {
                alertWarning("Failed to invite member! Refresh page and then try again");
            }
        });
    });

    $("body").on("click", "a[data-content=\"invited-group\"]", function (e) {
        e.preventDefault();
        var groupElement = $(this);
        var groupId = groupElement.data("container");

        yesNoCancelDialog("", "Do you accept membership in this group?", true, function (response) {
            var newStatus = "";
            if (response === true) {
                newStatus = "ACCEPTED";
            } else if (response === false) {
                newStatus = "DECLINED";
            } else {
                return;
            }

            $.ajax({
                url: Router.action("OnlinePartner", "ChangeMembershipStatus"),
                method: "PUT",
                data: { GroupId: groupId, NewStatus: newStatus },
                success: function (response) {
                    if (response && response.Result && response.Result === "OK") {
                        location.reload();
                    } else {
                        alertWarning("Failed to update status! Please refresh the page and then try again");
                    }
                },
                error: function () {
                    alertWarning("Failed to update status! Please refresh the page and then try again");
                }
            });
        });
    });

    $("body").on("click", "#leave-op-group", function (e) {
        console.log('ok?');
        e.preventDefault();

        yesNoCancelDialog("", "Do you really want to leave this group? You will lose access to shared analysis in this group!", false, function (response) {
            if (response === true) {
                try {
                    var splittedUrl = location.href.split('/');
                    var groupId = parseInt(splittedUrl.pop());
                } catch (e) {
                    console.error(e);
                    alertWarning("Failed to update status! Please refresh the page and then try again");
                    return;
                }

                $.ajax({
                    url: Router.action("OnlinePartner", "ChangeMembershipStatus"),
                    method: "PUT",
                    data: { GroupId: groupId, NewStatus: "LEFT" },
                    success: function (response) {
                        if (response && response.Result && response.Result === "OK") {
                            location = "/";
                        } else {
                            alertWarning("Failed to update status! Please refresh the page and then try again");
                        }
                    },
                    error: function () {
                        alertWarning("Failed to update status! Please refresh the page and then try again");
                    }
                });
            } else {
                return;
            }
        });
    });

    $("body").on("click", "#public-sharing-OneClick-On", function (e) {
        e.preventDefault();
        publishDialog(function (ok, comment, link) {
            if (ok) {
                var target = e.target || e.srcElement;
                var parent = $(target).closest(".share-company-line");
                var Id = parent.find(".share-company-id").val();

                $.ajax({
                    url: Router.action("Portfolio", "PublicSharingOneClick_On", { area: "Corp" }),
                    method: "POST",
                    data: { Id: Id, Description: comment, Link: link },
                    success: function (updated) {
                        $.ajax({
                            url: Router.action("UserAccess", "UserSharing"),
                            method: "GET",
                            success: function (data2) {
                                $("#master-body-content").html(data2);
                            }
                        });
                    },
                    error: function (request, status, error) {
                        messageDialog("Error", "Failed to publish analysis. If error persists, please contact the admin");
                    }
                });

            }           

        });
        
        return false;
    });

    // Copied from above and adjusted.
    $("body").on("click", "#ReportTemplatePublish", function (e) {
        e.preventDefault();

        confirmDialog("Confirm public sharing", "Are you sure you want to publicly share this analysis?", function (result) {

            if (result) {

                var target = e.target || e.srcElement;
                var parent = $(target).closest(".report-template-line");
                var ReportTemplateId = parent.find(".report-template-id").val();

                $.ajax({
                    url: Router.action("Portfolio", "PublishReportTemplate", { area: "Corp" }),
                    method: "POST",
                    data: { ReportTemplateId: ReportTemplateId },
                    success: function () {
                        $.ajax({
                            url: Router.action("UserAccess", "ManageTemplates"),
                            method: "GET",
                            success: function (data2) {
                                $("#master-body-content").html(data2);
                            }
                        });
                    }
                });

            }           

        });
        
        return false;
    });

    // New 2017 09 24
    $("body").on("click", "#public-sharing-OneClick-Off", function (e) {
        e.preventDefault();

        var target = e.target || e.srcElement;
        var parent = $(target).closest(".share-company-line");
        var Id = parent.find(".share-company-id").val();

        $.ajax({
            url: Router.action("Portfolio", "PublicSharingOneClick_Off", { area: "Corp" }), //form.attr("action"),
            method: "POST",
            data: { Id: Id },
            success: function (updated) {
                //setTimeout(function () {
                //    var date = moment.utc(updated, "MM/DD/YYYY-HH:mm:ss");
                //    var dateString = "";
                //    if (moment().diff(date, 'years') > 10) {
                //        dateString = "Never";
                //    } else {
                //        dateString = date.fromNow();
                //    }
                //    $(".snapshot-updated").text(dateString);
                //}, 1000);

                $.ajax({
                    url: Router.action("UserAccess", "UserSharing"),
                    method: "GET",
                    success: function (data2) {
                        $("#master-body-content").html(data2);
                    }
                });
            }
        });
        return false;
    });

    // Copied from above and adjusted.
    $("body").on("click", "#ReportTemplateUnpublish", function (e) {
        e.preventDefault();

        var target = e.target || e.srcElement;
        var parent = $(target).closest(".report-template-line");
        var ReportTemplateId = parent.find(".report-template-id").val();

        $.ajax({
            url: Router.action("Portfolio", "UnpublishReportTemplate", { area: "Corp" }),
            method: "POST",
            data: { ReportTemplateId: ReportTemplateId },
            success: function () {
                $.ajax({
                    url: Router.action("UserAccess", "ManageTemplates"),
                    method: "GET",
                    success: function (data2) {
                        $("#master-body-content").html(data2);
                    }
                });
            }
        });
        return false;
    });

    $("body").on("keyup", "#asset-filter", function () {
        buildAssetList($(this).val().toLowerCase());
    });

    $("body").on("change", "#AssetId", function () {
        var parent = $("#master-body-content");
        var id = $(".asset-main").val();
        if (id == null || id == "" || id == "0") {
            id = parent.find(".asset-ticker").val();
        }

        var type = parent.find(".asset-type").eq(0).val();
        var url = Router.action("Asset", "Currencies");
        if (type == 1) url = Router.action("Asset", "Shares");
        $.ajax({
            method: "GET",
            url: url,          /* 'Currencies' is used for both currencies and shares */
            data: { id: id },
            success: function (data) {
                parent.html(data);
            }
        });
    });

    $("body").on("click", ".asset-update", function (e) {
        e.preventDefault();                                             // PS! What does these do?, and what does the "function(e)" do?
        e.stopImmediatePropagation();
        var id = $(".asset-ticker").val();
        var parent = $("#master-body-content");
        if (id == null || id == "" || id == "0") {
            id = parent.find(".asset-ticker").val();
        }
        if (isNaN(parseInt(id)) || parseInt(id) <= 0) {
            alert('Please select an asset to update');
            return;
        }
        var r = confirm("Do you want to Get & Save an updated Live Price for this Currency from the market?");
        if (r == true) {
            
            var assetType = parent.find(".asset-type").eq(0).val();

            $.ajax({
                method: "POST",
                url: Router.action("Asset", "UpdateAssetPrice"),
                data: { AssetId: id, AssetType: assetType },
                success: function () {
                    location.reload();
                },
                error: function () {
                    alert("Failed to update selected asset");
                    location.reload();
                }
            });

            loadingDialog(".body-overlay", 500, 2000, 1, "Updating selected asset", "Please wait...", null, null, null, function (callback) {});
        }
    });

    $("body").on("click", ".asset-reload-current-IR", function (e) {
        e.preventDefault();                                             // PS! What does these do?, and what does the "function(e)" do?
        e.stopImmediatePropagation();
        var id = $(".asset-ticker").val();
        var parent = $("#master-body-content");
        if (id == null || id == "" || id == "0") {
            id = parent.find(".asset-ticker").val();
        }
        if (isNaN(parseInt(id)) || parseInt(id) <= 0) {
            alert('Please select an asset to reload IR');
            return;
        }
        var r = confirm("Do you want to Get & Save updated IR for selected currency?");
        if (r == true) {

            var assetType = parent.find(".asset-type").eq(0).val();

            $.ajax({
                method: "POST",
                url: Router.action("Asset", "ReloadCurrencyIR"),
                data: { AssetId: id, AssetType: assetType },
                success: function () {
                    location.reload();
                },
                error: function () {
                    alert("Failed to update selected asset");
                    location.reload();
                }
            });

            loadingDialog(".body-overlay", 500, 2000, 1, "Updating selected asset", "Please wait...", null, null, null, function (callback) { });
        }
    });

    $("body").on("click", ".asset-update-all", function () {
        var r = confirm("Do you want to Get & Save updated Live Price, Daily Price, and Monthly Price (if new month) from the market? For all Share or Currencies in Fehirde Market Database+");
        if (r == true) {
            var parent = $("#master-body-content");
            var assetType = parent.find(".asset-type").eq(0).val();

            $.ajax({
                method: "POST",
                url: Router.action("Asset", "UpdateAllPrices"),
                data: { AssetType: assetType },
                success: function () {
                    location.reload();
                },
                error: function () {
                    alert("Failed to update assets");
                    location.reload();
                }
            });

            loadingDialog(".body-overlay", 500, 2000, 1, "Updating assets", "Please wait - this can take some time, depending how old is existing data", null, null, null, function (callback) { });
        }
    });

    $("body").on("click", ".asset-reload-all-IR", function () {
        var r = confirm("Do you want to Get & Save updated IR for all currencies?");
        if (r == true) {
            var parent = $("#master-body-content");
            var assetType = parent.find(".asset-type").eq(0).val();

            $.ajax({
                method: "POST",
                url: Router.action("Asset", "ReloadAllIR"),
                data: { AssetType: assetType },
                success: function () {
                    location.reload();
                },
                error: function () {
                    alert("Failed to update assets IR");
                    location.reload();
                }
            });

            loadingDialog(".body-overlay", 500, 2000, 1, "Updating assets", "Please wait - this can take some time, depending how old is existing data", null, null, null, function (callback) { });
        }
    });

    $("body").on("click", ".asset-rebuild-history-month", function (e) {
        e.preventDefault();                     // What does these do?, and what does the "function(e)" do?
        e.stopImmediatePropagation();
        var parent = $("#master-body-content");
        var AssetId = parent.find(".asset-ticker").val();
        var assetType = parent.find(".asset-type").eq(0).val();

        var UpdateFunc = function (PriceType) {
            $.ajax({
                method: "POST",
                url: Router.action("Asset", "UpdateAssetHistory"),
                data: { AssetId: AssetId, PriceType: PriceType, MonthOnly: true, AssetType: assetType },
                success: function () {
                    alert("Jepp!");
                }
            });
        };

        $("<div><p>Which part of the history do you want to rebuild from external source?</p></div>").dialog({
            resizable: false,
            model: true,
            buttons: {
                "Daily data": function () {
                    UpdateFunc(0);
                    $(this).dialog("close");
                },
                "Monthly data": function () {
                    UpdateFunc(1);
                    $(this).dialog("close");
                },
                "Both": function () {
                    UpdateFunc(2);
                    $(this).dialog("close");
                },
                Cancel: function () {
                    $(this).dialog("close");
                }
            }
        });
    });

    $("body").on("click", ".asset-rebuild-history", function (e) {
        e.preventDefault();                     // What does these do?, and what does the "function(e)" do?
        e.stopImmediatePropagation();
        var parent = $("#master-body-content");
        var AssetId = parent.find(".asset-ticker").val();
        var assetType = parent.find(".asset-type").eq(0).val();

        var UpdateFunc = function (PriceType) {
            $.ajax({
                method: "POST",
                url: Router.action("Asset", "UpdateAssetHistory"),
                data: { AssetId: AssetId, PriceType: PriceType, AssetType: assetType },
                success: function () {
                    alert("Jepp!");
                }
            });
        };

        $("<div><p>Which part of the history do you want to rebuild from external source?</p></div>").dialog({
            resizable: false,
            model: true,
            buttons: {
                "Daily data": function () {
                    UpdateFunc(0);
                    $(this).dialog("close");
                },
                "Monthly data": function () {
                    UpdateFunc(1);
                    $(this).dialog("close");
                },
                "Both": function () {
                    UpdateFunc(2);
                    $(this).dialog("close");
                },
                Cancel: function () {
                    $(this).dialog("close");
                }
            }
        });
    });

    // This is (unfortunately?) not used anymore
    $("body").on("click", ".asset-FXHistoryDaily", function (e) {
        var r = confirm("Do you want to update ALL Daily historic FX rates for this Ticker?");
        if (r == true) {
            var type = 4;
            e.preventDefault();                     // What does these do?, and what does the "function(e)" do?
            e.stopImmediatePropagation();
            var parent = $("#master-body-content");
            var id = $(".asset-main").val();
            if (id == null || id == "" || id == "0") {
                id = parent.find(".asset-ticker").val();
            }
            $.ajax({
                method: "POST",
                url: Router.action("Asset", "UpdateFXRates"),
                data: { Ticker: id, UpdateType: type },
                success: function () {
                    alert("Jepp!");
                }
            });
        }
    });

    $("body").on("click", ".asset-FXHistoryMonthly", function (e) {
        var r = confirm("Do you want to update ALL Daily historic FX rates for this Ticker?");
        if (r == true) {
            var type = 5;
            e.preventDefault();                     // What does these do?, and what does the "function(e)" do?
            e.stopImmediatePropagation();
            var parent = $("#master-body-content");
            var id = $(".asset-main").val();
            if (id == null || id == "" || id == "0") {
                id = parent.find(".asset-ticker").val();
            }
            $.ajax({
                method: "POST",
                url: Router.action("Asset", "UpdateFXRates"),
                data: { Ticker: id, UpdateType: type },
                success: function () {
                    alert("Jepp!");
                }
            });
        }
    });

    // Add Daily Data to all FX Tickers...PS! Separate source than Yahoo!...Using Themoneyconverter, and ECB for which they have fixings...
    $("body").on("click", ".asset-FXAddDaily", function (e) {
        var r = confirm("Do you want to Add 1 Daily historic FX rate for ALL FX's?");
        if (r == true) {
            var type = 6;
            e.preventDefault();                     // What does these do?, and what does the "function(e)" do?
            e.stopImmediatePropagation();
            var parent = $("#master-body-content");
            var id = $(".asset-main").val();
            if (id == null || id == "" || id == "0") {
                id = parent.find(".asset-ticker").val();
            }
            $.ajax({
                method: "POST",
                url: Router.action("Asset", "UpdateFXRates"),
                data: { Ticker: id, UpdateType: type },
                success: function () {
                    alert("Jepp!");
                }
            });
        }
    });

    // FIX MONTHLT ADD ! ! !!
    $("body").on("click", ".asset-FXAddMonthly", function (e) {
        var r = confirm("Do you want to Add 1 Monthly historic FX rates for ALL FX's?");
        if (r == true) {
            var type = 7;
            e.preventDefault();                     // What does these do?, and what does the "function(e)" do?
            e.stopImmediatePropagation();
            var parent = $("#master-body-content");
            var id = $(".asset-main").val();
            if (id == null || id == "" || id == "0") {
                id = parent.find(".asset-ticker").val();
            }
            $.ajax({
                method: "POST",
                url: Router.action("Asset", "UpdateFXRates"),
                data: { Ticker: id, UpdateType: type },
                success: function () {
                    alert("Jepp!");
                }
            });
        }
    });

    $("body").on("click", "#asset-init-div .selectall", function () {
        var parent = $(this).closest("#asset-init-div");
        parent.find("table input[type='checkbox']:visible").attr("checked", "checked");
    });

    $("body").on("click", "#asset-init-div .selectnone", function () {
        var parent = $(this).closest("#asset-init-div");
        parent.find("table input[type='checkbox']:visible").removeAttr("checked");
    });

    $("body").on("click", ".asset-initialize-database-month", function () {
        var parent = $("#master-body-content");
        var type = parent.find(".asset-type").eq(0).val();
        //var r = confirm("Do you want to initialize database?");
        $.ajax({
            method: "GET",
            url: Router.action("Asset", "GetUpdateList"),
            data: { AssetType: type, UpdateOnly: true },
            success: function (dataTest) {
                var parent = $("<div id=\"asset-init-div\" />");
                var div = $("<div style='overflow: auto; height: 500px;' />");
                var div2 = $("<div style='overflow: auto;' />");
                var table = $("<table style='width: 100%' />");

                var fact = Math.ceil(dataTest.length / 5);
                for (var i = 0; i < fact; i++) {
                    var row = $("<tr />");
                    row.append("<td><input style=\"margin-right: 5px;\" type='checkbox' /><label>" + dataTest[i].Ticker + "</label></td>");
                    var j = parseInt((fact * 1) + i);
                    if (j < dataTest.length) {
                        row.append("<td><input style=\"margin-right: 5px;\" type='checkbox' /><label>" + dataTest[j].Ticker + "</label></td>");
                    } else {
                        row.append("<td></td><td></td>");
                    }
                    var j = parseInt((fact * 2) + i);
                    if (j < dataTest.length) {
                        row.append("<td><input style=\"margin-right: 5px;\" type='checkbox' /><label>" + dataTest[j].Ticker + "</label></td>");
                    } else {
                        row.append("<td></td><td></td>");
                    }
                    var j = parseInt((fact * 3) + i);
                    if (j < dataTest.length) {
                        row.append("<td><input style=\"margin-right: 5px;\" type='checkbox' /><label>" + dataTest[j].Ticker + "</label></td>");
                    } else {
                        row.append("<td></td><td></td>");
                    }
                    var j = parseInt((fact * 4) + i);
                    if (j < dataTest.length) {
                        row.append("<td><input style=\"margin-right: 5px;\" type='checkbox' /><label>" + dataTest[j].Ticker + "</label></td>");
                    } else {
                        row.append("<td></td><td></td>");
                    }
                    table.append(row);
                }

                div.append(table);
                div2.append("<input type='text' class='init-filter form-control' placeholder='filter' /><span><input class='init-exclude' type='checkbox' style='margin-right: 5px;' />US only</span>");
                div2.append("<button class=\"btn btn-sm btn-link selectall\" style=\"\">Select All</button><button class=\"btn btn-sm btn-link selectnone\" style=\"\">Select None</button><br />");
                div2.append("<hr style=\"width: 100%\" />");
                parent.append(div2);
                parent.append(div);

                bootbox.dialog({
                    title: "Initialize Database",
                    message: parent,
                    buttons: {
                        Rebuild: {
                            label: "Rebuild",
                            className: "btn-default",
                            callback: function () {
                                var AssetList = $("#asset-init-div input[type='checkbox']:visible:checked").map(function () { return $(this).closest("td").find("label").text(); }).get().sort();

                                loadingDialog(".body-overlay", 2000, 2000, 1, null, "Rebuilding assets", "Building: ", null, null, function (callback) {
                                    ProcessAssetUpdate(AssetList, type, Router.action("Asset", "AddExternalAsset", { MonthOnly: true }), 0, callback);
                                });
                            }
                        },
                        Cancel: {
                            label: "Cancel",
                            className: "btn-default",
                            callback: function () {
                            }
                        }
                    }
                });
            }
        });
    });

    $("body").on("click", ".asset-initialize-database", function () {
        var parent = $("#master-body-content");
        var type = parent.find(".asset-type").eq(0).val();
        var stringType = type == 0 ? "currency" : "share";

        var r = confirm("This will delete all current " + stringType + " data and initialize database! Do you want to proceed?");
        if (r == true) {
            $.ajax({
                method: "POST",
                url: Router.action("Asset", "InitializeDB"),
                data: { AssetType: type },
                success: function () {
                    location.reload();
                },
                error: function () {
                    alert("Failed to initialize assets DB");
                    location.reload();
                }
            });

            loadingDialog(".body-overlay", 2000, 2000, 1, null, "Initializing assets DB", "Please wait - this can take a few minutes.", null, null, function (callback) {});
        }
    });

    $("body").on("change", "#asset-init-div .init-exclude", function () {
        var filter = $("#asset-init-div .init-filter").val().toLowerCase();
        var exclude = $(this).is(":checked");

        $("#asset-init-div table td").each(function () {
            var text = $(this).text().toLowerCase();
            if (exclude && text.indexOf(".") >= 0) {
                $(this).hide();
            } else {
                if (text == "" || text.indexOf(filter) >= 0) {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            }
        });
    });

    $("body").on("keyup", "#asset-init-div .init-filter", function () {
        var filter = $(this).val().toLowerCase();
        var exclude = $("#asset-init-div .init-exclude").is(":checked");

        $("#asset-init-div table td").each(function () {
            var text = $(this).text().toLowerCase();
            if (exclude && text.indexOf(".") >= 0) {
                $(this).hide();
            } else {
                if (text == "" || text.indexOf(filter) >= 0) {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            }
        });
    });

    /* Common for Share and FX's  */
    $("body").on("change", ".asset-ticker", function () {
        // alert("Has commented away the Get method, to avoid error if to long history. Fix Eivinds jquery idea wrt loading dynamically e.g. 20 and 20");

        //        var id = $(this).val();
        //        var parent = $(this).closest(".asset-main");
        //        var type = parent.find(".asset-type").eq(0).val();

        //        $.ajax({
        //            method: "GET",
        //            url: Router.action("Asset", "Currencies"),
        //            data: { AssetType: type, id: id },
        //            success: function (data) {
        //                parent.html(data);
        //            }
        //        });
    });

    $("body").on("click", ".asset-new-external", function () {
        var r = confirm("Do you want to create a New External Asset? Historic and live prices are fetched from the market if ticker is correct");
        if (r == true) {
            var parent = $("#master-body-content");
            var type = parent.find(".asset-type").eq(0).val();
            var asset = ((type == 0) ? "currency" : "share");

            var existingTickerLabels = [...document.getElementById("AssetId").options].map(function (option) {
                return option.text === "" || option.text === "(New)" ? null : option.text;
            }).filter(function (label) {
                return label !== null;
            });

            inputDialog("New " + asset, "Please input " + asset + " ticker", function (data) {
                if (data == null || data == "") {
                    messageDialog("Error", "No " + asset + " name provided", null, null);
                } else if (existingTickerLabels.includes(data)) {
                    messageDialog("Error", "Asset " + data + " already exists", null, null);
                }
                else {
                    $.ajax({
                        method: "POST",
                        url: Router.action("Asset", "AddExternalAsset"),
                        data: { AssetType: type, Ticker: data, Overwrite: true },
                        success: function () {
                            location.reload();
                        },
                        error: function () {
                            alert('Failed to add external asset');
                            location.reload();
                        }
                    });

                    loadingDialog(".body-overlay", 1000, 2000, 1, null, "Adding new asset to the DB", "Please wait...", null, null, function (callback) { });
                }
            });
        }
    });

    $("body").on("click", ".asset-new-custom", function () {
        var r = confirm("Do you want to create a New Individual Asset? Individual Asset requires to manually input historic prices.");
        if (r == true) {
            var parent = $("#master-body-content");
            var type = parent.find(".asset-type").eq(0).val();
            var asset = ((type == 0) ? "currency" : "share");
            inputDialog("New " + asset, "Please input " + asset + " ticker", function (data) {
                if (data == null || data == "") {
                    messageDialog("Error", "No " + asset + " name provided", null, null);
                }
                $.ajax({
                    method: "POST",
                    url: Router.action("Asset", "AddNewIndividualAsset"),
                    data: { Ticker: data, AssetType: type },
                    success: function () {
                        $.ajax({
                            method: "GET",
                            url: Router.action("Asset", "Currencies"),
                            data: { AssetType: type, id: 0 },
                            success: function (data2) {
                                parent.html(data2);

                                alert("Jepp!");
                            }
                        });
                    }
                });
            });
        }
    });

    $("body").on("click", ".asset-save", function () {
        var r = confirm("Do you want to Save this Asset?");
        if (r == true) {
            var parent = $("#master-body-content");

            submitForm(parent.find("form").eq(0), function (data) {
                parent.html(data);
            });
            //alert("Saved...nope......:(");
        }
    });

    $("body").on("click", ".asset-delete", function () {
        var parent = $("#master-body-content");
        var assetId = parent.find("select[name='AssetId']").eq(0).val();
        var parsedAssetId = parseInt(assetId);
        if (isNaN(parsedAssetId) || parsedAssetId <= 0) {
            alert('Please select an asset to delete');
            return;
        }
        var r = confirm("Do you want to delete this Share or FX?");
        if (r == true) {
            var s = confirm("Are you Really Really sure you want to delete this Share or FX?");

            if (s == true) {
                
                var assetType = parent.find(".asset-type").eq(0).val();
                var assetId = parent.find("select[name='AssetId']").eq(0).val();
                $.ajax({
                    method: "POST",
                    url: Router.action("Asset", "DeleteAsset"),
                    data: { AssetType: assetType, AssetId: assetId },
                    success: function (data) {
                        parent.html(data);
                        location.reload();
                    },
                    error: function (data) {
                        alert('Failed to delete asset');
                        location.reload();
                    },
                    statusCode: {
                        404: function () {
                            alert("Not found!");
                        }
                    },
                    complete: function (data) { }
                });

                loadingDialog(".body-overlay", 500, 2000, 1, null, "Deleteing asset from DB", "Please wait...", null, null, function (callback) { });
            }
        }
    });

    $("body").on("click", ".fx-daily-nav .next a", function (e) {
        e.preventDefault();
        if ($(this).closest("li").hasClass("disabled")) { return false; }
        var AssetId = $("select[id$='AssetId'").val();
        var CurrentIndex = $(".fx-daily-prices .pager-current").val();
        GetCurrencyDailyPrice(AssetId, parseInt(CurrentIndex) + 1);
    });

    $("body").on("click", ".fx-monthly-nav .next a", function (e) {
        e.preventDefault();
        if ($(this).closest("li").hasClass("disabled")) { return false; }
        var AssetId = $("select[id$='AssetId'").val();
        var CurrentIndex = $(".fx-monthly-prices .pager-current").val();
        GetCurrencyMonthlyPrice(AssetId, parseInt(CurrentIndex) + 1);
    });

    $("body").on("click", ".fx-daily-nav .previous a", function (e) {
        e.preventDefault();
        if ($(this).closest("li").hasClass("disabled")) { return false; }
        var AssetId = $("select[id$='AssetId'").val();
        var CurrentIndex = $(".fx-daily-prices .pager-current").val();
        GetCurrencyDailyPrice(AssetId, parseInt(CurrentIndex) - 1);
    });

    $("body").on("click", ".fx-monthly-nav .previous a", function (e) {
        e.preventDefault();
        if ($(this).closest("li").hasClass("disabled")) { return false; }
        var AssetId = $("select[id$='AssetId'").val();
        var CurrentIndex = $(".fx-monthly-prices .pager-current").val();
        GetCurrencyMonthlyPrice(AssetId, parseInt(CurrentIndex) - 1);
    });

    $("body").on("click", ".share-daily-nav .next a", function (e) {
        e.preventDefault();
        if ($(this).closest("li").hasClass("disabled")) { return false; }
        var AssetId = $("select[id$='AssetId'").val();
        var CurrentIndex = $(".share-daily-prices .pager-current").val();
        GetShareDailyPrice(AssetId, parseInt(CurrentIndex) + 1);
    });

    $("body").on("click", ".share-monthly-nav .next a", function (e) {
        e.preventDefault();
        if ($(this).closest("li").hasClass("disabled")) { return false; }
        var AssetId = $("select[id$='AssetId'").val();
        var CurrentIndex = $(".share-monthly-prices .pager-current").val();
        GetShareMonthlyPrice(AssetId, parseInt(CurrentIndex) + 1);
    });

    $("body").on("click", ".share-daily-nav .previous a", function (e) {
        e.preventDefault();
        if ($(this).closest("li").hasClass("disabled")) { return false; }
        var AssetId = $("select[id$='AssetId'").val();
        var CurrentIndex = $(".share-daily-prices .pager-current").val();
        GetShareDailyPrice(AssetId, parseInt(CurrentIndex) - 1);
    });

    $("body").on("click", ".share-monthly-nav .previous a", function (e) {
        e.preventDefault();
        if ($(this).closest("li").hasClass("disabled")) { return false; }
        var AssetId = $("select[id$='AssetId'").val();
        var CurrentIndex = $(".share-monthly-prices .pager-current").val();
        GetShareMonthlyPrice(AssetId, parseInt(CurrentIndex) - 1);
    });

    $("body").on("click", ".browse-companies-nav .next a", function (e) {
        e.preventDefault();
        var liElement = $(this).closest("li");
        if (liElement.hasClass("disabled")) { return false; }
        var query = $("#browse-companies-query").val();
        var CurrentIndex = $(".browse-companies-table .pager-current").val();
        if (liElement.data("content") === "tutorials") {
            GetTutorialsList(query, parseInt(CurrentIndex) + 1);
        } else {
            GetCompanyList(query, parseInt(CurrentIndex) + 1);
        }
    });

    $("body").on("click", ".browse-companies-nav .previous a", function (e) {
        e.preventDefault();
        var liElement = $(this).closest("li");
        if (liElement.hasClass("disabled")) { return false; }
        var query = $("#browse-companies-query").val();
        var CurrentIndex = $(".browse-companies-table .pager-current").val();
        if (liElement.data("content") === "tutorials") {
            GetTutorialsList(query, parseInt(CurrentIndex) - 1);
        } else {
            GetCompanyList(query, parseInt(CurrentIndex) - 1);
        }
    });

    $("body").on("click", ".browse-report-templates-nav .next a", function (e) {
        e.preventDefault();
        if ($(this).closest("li").hasClass("disabled")) { return false; }
        var query = $("#browse-report-templates-query").val();
        var CurrentIndex = $(".browse-report-templates-table .pager-current").val();
        GetReportTempaltesList(query, parseInt(CurrentIndex) + 1);
    });

    $("body").on("click", ".browse-report-templates-nav .previous a", function (e) {
        e.preventDefault();
        if ($(this).closest("li").hasClass("disabled")) { return false; }
        var query = $("#browse-report-templates-query").val();
        var CurrentIndex = $(".browse-report-templates-table .pager-current").val();
        GetReportTempaltesList(query, parseInt(CurrentIndex) - 1);
    });

    $("body").on("keyup", "#browse-companies-query", function () {
        var tableType = $(this).data("content");
        var query = $(this).val();
        if (tableType === "tutorials") {
            GetTutorialsList(query, 1);
        } else {
            GetCompanyList(query, 1);
        }
    });

    $("body").on("keyup", "#browse-report-templates-query", function () {
        var query = $(this).val();
        GetReportTempaltesList(query, 1);
    });

    $("body").on("focus", ".excel-paste input[type='text']", function () {
        $(this).select();
    });

    $("body").on("paste", ".excel-paste input[type='text']", function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var pastedText = undefined;
        if (window.clipboardData && window.clipboardData.getData) { // IE
            pastedText = window.clipboardData.getData('Text');
        } else if (e.originalEvent.clipboardData && e.originalEvent.clipboardData.getData) {
            pastedText = e.originalEvent.clipboardData.getData('text/plain');
        } else {
            return false;
        }
        var rows = pastedText.split("\n");
        var currentRow = $(this).closest("tr");
        var siblings = $(this).closest("tr").find(".excel-paste input[type='text']");
        var domRows = $(this).closest("tbody").find("tr");

        // Find current row
        var rowIndex = domRows.index(currentRow);

        // Find current element in row
        var elemIndex = siblings.index(this);

        if (rowIndex < 0 || elemIndex < 0) {
            return false;
        }

        var minRowLength = rows.length + rowIndex < domRows.length ? rows.length + rowIndex : domRows.length;

        for (let i = rowIndex; i < minRowLength; i++) {
            let cells = rows[i - rowIndex].split("\t");
            let numElements = cells.length;
            siblings = domRows.eq(i).find(".excel-paste input[type='text']");

            var minLength = numElements + elemIndex < siblings.length ? numElements + elemIndex : siblings.length;

            for (var j = elemIndex; j < minLength; j++) {
                siblings.eq(j).val(cells[j - elemIndex]);
            }
        }

        // trigger keydown event (hack)
        $(this).trigger("keydown");

        return false;
    });

    $("body").on("click", ".ImportPublishedReportTemplate", function (e) {

        var ReportTemplateId = $(this).closest('tr').find('.ReportTemplateId').text();

        $.ajax({
            url: Router.action("Tab", "ImportPublishedReportTemplate"),
            method: "POST",
            data: { ReportTemplateId: ReportTemplateId },
            success: function (data) {

            }
        });

    });

    //Upload Excel File Click Handler
    $("body").on("click", "#upload-from-excel", function () {
        var contr = $(this).data("controller");
        var method = $(this).data("method");
        var area = $(this).data("area");
        loadDataFromExcelDialog(contr, method, area, GetCompanyId());
        return false;
    });

    //Filedrop jquery plugin
    (function ($) {
        var default_opts = {
            fallback_id: '',
            fallback_dropzoneClick: true,
            url: '',
            refresh: 1000,
            paramname: 'userfile',
            requestType: 'POST',    // just in case you want to use another HTTP verb
            allowedfileextensions: [],
            allowedfiletypes: [],
            maxfiles: 25,           // Ignored if queuefiles is set > 0
            maxfilesize: 1,         // MB file size limit
            queuefiles: 0,          // Max files before queueing (for large volume uploads)
            queuewait: 200,         // Queue wait time if full
            data: {},
            headers: {},
            drop: empty,
            dragStart: empty,
            dragEnter: empty,
            dragOver: empty,
            dragLeave: empty,
            docEnter: empty,
            docOver: empty,
            docLeave: empty,
            beforeEach: empty,
            afterAll: empty,
            rename: empty,
            error: function (err, file, i, status) {
                alert(err);
            },
            uploadStarted: empty,
            uploadFinished: empty,
            progressUpdated: empty,
            globalProgressUpdated: empty,
            speedUpdated: empty
        },
            errors = ["BrowserNotSupported", "TooManyFiles", "FileTooLarge", "FileTypeNotAllowed", "NotFound", "NotReadable", "AbortError", "ReadError", "FileExtensionNotAllowed"];

        $.fn.filedrop = function (options) {
            var opts = $.extend({}, default_opts, options),
                global_progress = [],
                doc_leave_timer, stop_loop = false,
                files_count = 0,
                files;

            if (opts.fallback_dropzoneClick === true) {
                $('#' + opts.fallback_id).css({
                    display: 'none',
                    width: 0,
                    height: 0
                });
            }

            this.on('drop', drop).on('dragstart', opts.dragStart).on('dragenter', dragEnter).on('dragover', dragOver).on('dragleave', dragLeave);
            $(document).on('drop', docDrop).on('dragenter', docEnter).on('dragover', docOver).on('dragleave', docLeave);

            if (opts.fallback_dropzoneClick === true) {
                if (this.find('#' + opts.fallback_id).length > 0) {
                    throw "Fallback element [" + opts.fallback_id + "] cannot be inside dropzone, unless option fallback_dropzoneClick is false";
                }
                else {
                    this.on('click', function (e) {
                        $('#' + opts.fallback_id).trigger(e);
                    });
                }
            }

            $('#' + opts.fallback_id).change(function (e) {
                opts.drop(e);
                files = e.target.files;
                files_count = files.length;
                upload();
            });

            function drop(e) {
                if (opts.drop.call(this, e) === false) return false;
                if (!e.originalEvent.dataTransfer)
                    return;
                files = e.originalEvent.dataTransfer.files;
                if (files === null || files === undefined || files.length === 0) {
                    opts.error(errors[0]);
                    return false;
                }
                files_count = files.length;
                upload();
                e.preventDefault();
                return false;
            }

            function getBuilder(filename, filedata, mime, boundary) {
                var dashdash = '--',
                    crlf = '\r\n',
                    builder = '',
                    paramname = opts.paramname;

                if (opts.data) {
                    var params = $.param(opts.data).replace(/\+/g, '%20').split(/&/);

                    $.each(params, function () {
                        var pair = this.split("=", 2),
                            name = decodeURIComponent(pair[0]),
                            val = decodeURIComponent(pair[1]);

                        if (pair.length !== 2) {
                            return;
                        }

                        builder += dashdash;
                        builder += boundary;
                        builder += crlf;
                        builder += 'Content-Disposition: form-data; name="' + name + '"';
                        builder += crlf;
                        builder += crlf;
                        builder += val;
                        builder += crlf;
                    });
                }

                if (jQuery.isFunction(paramname)) {
                    paramname = paramname(filename);
                }

                builder += dashdash;
                builder += boundary;
                builder += crlf;
                builder += 'Content-Disposition: form-data; name="' + (paramname || "") + '"';
                builder += '; filename="' + encodeURIComponent(filename) + '"';
                builder += crlf;

                builder += 'Content-Type: ' + mime;
                builder += crlf;
                builder += crlf;

                builder += filedata;
                builder += crlf;

                builder += dashdash;
                builder += boundary;
                builder += dashdash;
                builder += crlf;
                return builder;
            }

            function progress(e) {
                if (e.lengthComputable) {
                    var percentage = Math.round((e.loaded * 100) / e.total);
                    if (this.currentProgress !== percentage) {

                        this.currentProgress = percentage;
                        opts.progressUpdated(this.index, this.file, this.currentProgress);

                        global_progress[this.global_progress_index] = this.currentProgress;
                        globalProgress();

                        var elapsed = new Date().getTime();
                        var diffTime = elapsed - this.currentStart;
                        if (diffTime >= opts.refresh) {
                            var diffData = e.loaded - this.startData;
                            var speed = diffData / diffTime; // KB per second
                            opts.speedUpdated(this.index, this.file, speed);
                            this.startData = e.loaded;
                            this.currentStart = elapsed;
                        }
                    }
                }
            }

            function globalProgress() {
                if (global_progress.length === 0) {
                    return;
                }

                var total = 0, index;
                for (index in global_progress) {
                    if (global_progress.hasOwnProperty(index)) {
                        total = total + global_progress[index];
                    }
                }

                opts.globalProgressUpdated(Math.round(total / global_progress.length));
            }

            // Respond to an upload
            function upload() {
                stop_loop = false;

                if (!files) {
                    opts.error(errors[0]);
                    return false;
                }

                if (opts.allowedfiletypes.push && opts.allowedfiletypes.length) {
                    for (var fileIndex = files.length; fileIndex--;) {
                        if (!files[fileIndex].type || $.inArray(files[fileIndex].type, opts.allowedfiletypes) < 0) {
                            opts.error(errors[3], files[fileIndex]);
                            return false;
                        }
                    }
                }

                if (opts.allowedfileextensions.push && opts.allowedfileextensions.length) {
                    for (var fileIndex = files.length; fileIndex--;) {
                        var allowedextension = false;
                        for (i = 0; i < opts.allowedfileextensions.length; i++) {
                            if (files[fileIndex].name.substr(files[fileIndex].name.length - opts.allowedfileextensions[i].length).toLowerCase()
                                == opts.allowedfileextensions[i].toLowerCase()
                            ) {
                                allowedextension = true;
                            }
                        }
                        if (!allowedextension) {
                            opts.error(errors[8], files[fileIndex]);
                            return false;
                        }
                    }
                }

                var filesDone = 0,
                    filesRejected = 0;

                if (files_count > opts.maxfiles && opts.queuefiles === 0) {
                    opts.error(errors[1]);
                    return false;
                }

                // Define queues to manage upload process
                var workQueue = [];
                var processingQueue = [];
                var doneQueue = [];

                // Add everything to the workQueue
                for (var i = 0; i < files_count; i++) {
                    workQueue.push(i);
                }

                // Helper function to enable pause of processing to wait
                // for in process queue to complete
                var pause = function (timeout) {
                    setTimeout(process, timeout);
                    return;
                };

                // Process an upload, recursive
                var process = function () {

                    var fileIndex;

                    if (stop_loop) {
                        return false;
                    }

                    // Check to see if are in queue mode
                    if (opts.queuefiles > 0 && processingQueue.length >= opts.queuefiles) {
                        return pause(opts.queuewait);
                    } else {
                        // Take first thing off work queue
                        fileIndex = workQueue[0];
                        workQueue.splice(0, 1);

                        // Add to processing queue
                        processingQueue.push(fileIndex);
                    }

                    try {
                        if (beforeEach(files[fileIndex]) !== false) {
                            if (fileIndex === files_count) {
                                return;
                            }
                            var reader = new FileReader(),
                                max_file_size = 1048576 * opts.maxfilesize;

                            reader.index = fileIndex;
                            if (files[fileIndex].size > max_file_size) {
                                opts.error(errors[2], files[fileIndex], fileIndex);
                                // Remove from queue
                                processingQueue.forEach(function (value, key) {
                                    if (value === fileIndex) {
                                        processingQueue.splice(key, 1);
                                    }
                                });
                                filesRejected++;
                                return true;
                            }

                            reader.onerror = function (e) {
                                switch (e.target.error.code) {
                                    case e.target.error.NOT_FOUND_ERR:
                                        opts.error(errors[4]);
                                        return false;
                                    case e.target.error.NOT_READABLE_ERR:
                                        opts.error(errors[5]);
                                        return false;
                                    case e.target.error.ABORT_ERR:
                                        opts.error(errors[6]);
                                        return false;
                                    default:
                                        opts.error(errors[7]);
                                        return false;
                                };
                            };

                            reader.onloadend = !opts.beforeSend ? send : function (e) {
                                opts.beforeSend(files[fileIndex], fileIndex, function () { send(e); });
                            };

                            reader.readAsDataURL(files[fileIndex]);

                        } else {
                            filesRejected++;
                        }
                    } catch (err) {
                        // Remove from queue
                        processingQueue.forEach(function (value, key) {
                            if (value === fileIndex) {
                                processingQueue.splice(key, 1);
                            }
                        });
                        opts.error(errors[0]);
                        return false;
                    }

                    // If we still have work to do,
                    if (workQueue.length > 0) {
                        process();
                    }
                };

                var send = function (e) {

                    var fileIndex = (e.srcElement || e.target).index;

                    // Sometimes the index is not attached to the
                    // event object. Find it by size. Hack for sure.
                    if (e.target.index === undefined) {
                        e.target.index = getIndexBySize(e.total);
                    }

                    var xhr = new XMLHttpRequest(),
                        upload = xhr.upload,
                        file = files[e.target.index],
                        index = e.target.index,
                        start_time = new Date().getTime(),
                        boundary = '------multipartformboundary' + (new Date()).getTime(),
                        global_progress_index = global_progress.length,
                        builder,
                        newName = rename(file.name),
                        mime = file.type;

                    if (opts.withCredentials) {
                        xhr.withCredentials = opts.withCredentials;
                    }

                    var encodedString = e.target.result.split(',')[1];
                    var data = encodedString === undefined ? '' : atob(encodedString);
                    if (typeof newName === "string") {
                        builder = getBuilder(newName, data, mime, boundary);
                    } else {
                        builder = getBuilder(file.name, data, mime, boundary);
                    }

                    upload.index = index;
                    upload.file = file;
                    upload.downloadStartTime = start_time;
                    upload.currentStart = start_time;
                    upload.currentProgress = 0;
                    upload.global_progress_index = global_progress_index;
                    upload.startData = 0;
                    upload.addEventListener("progress", progress, false);

                    // Allow url to be a method
                    if (jQuery.isFunction(opts.url)) {
                        xhr.open(opts.requestType, opts.url(upload), true);
                    } else {
                        xhr.open(opts.requestType, opts.url, true);
                    }

                    xhr.setRequestHeader('content-type', 'multipart/form-data; boundary=' + boundary);
                    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");

                    // Add headers
                    $.each(opts.headers, function (k, v) {
                        xhr.setRequestHeader(k, v);
                    });

                    if (!xhr.sendAsBinary) {
                        xhr.sendAsBinary = function (datastr) {
                            function byteValue(x) {
                                return x.charCodeAt(0) & 0xff;
                            }
                            var ords = Array.prototype.map.call(datastr, byteValue);
                            var ui8a = new Uint8Array(ords);
                            this.send(ui8a.buffer);
                        }
                    }

                    xhr.sendAsBinary(builder);

                    global_progress[global_progress_index] = 0;
                    globalProgress();

                    opts.uploadStarted(index, file, files_count);

                    xhr.onload = function () {
                        var serverResponse = null;

                        if (xhr.responseText) {
                            try {
                                serverResponse = jQuery.parseJSON(xhr.responseText);
                            }
                            catch (e) {
                                serverResponse = xhr.responseText;
                            }
                        }

                        var now = new Date().getTime(),
                            timeDiff = now - start_time,
                            result = opts.uploadFinished(index, file, serverResponse, timeDiff, xhr);
                        filesDone++;

                        // Remove from processing queue
                        processingQueue.forEach(function (value, key) {
                            if (value === fileIndex) {
                                processingQueue.splice(key, 1);
                            }
                        });

                        // Add to donequeue
                        doneQueue.push(fileIndex);

                        // Make sure the global progress is updated
                        global_progress[global_progress_index] = 100;
                        globalProgress();

                        if (filesDone === (files_count - filesRejected)) {
                            afterAll();
                        }
                        if (result === false) {
                            stop_loop = true;
                        }


                        // Pass any errors to the error option
                        if (xhr.status < 200 || xhr.status > 299) {
                            opts.error(xhr.statusText, file, fileIndex, xhr.status);
                        }
                    };
                };

                // Initiate the processing loop
                process();
            }

            function getIndexBySize(size) {
                for (var i = 0; i < files_count; i++) {
                    if (files[i].size === size) {
                        return i;
                    }
                }

                return undefined;
            }

            function rename(name) {
                return opts.rename(name);
            }

            function beforeEach(file) {
                return opts.beforeEach(file);
            }

            function afterAll() {
                return opts.afterAll();
            }

            function dragEnter(e) {
                clearTimeout(doc_leave_timer);
                e.preventDefault();
                opts.dragEnter.call(this, e);
            }

            function dragOver(e) {
                clearTimeout(doc_leave_timer);
                e.preventDefault();
                opts.docOver.call(this, e);
                opts.dragOver.call(this, e);
            }

            function dragLeave(e) {
                clearTimeout(doc_leave_timer);
                opts.dragLeave.call(this, e);
                e.stopPropagation();
            }

            function docDrop(e) {
                e.preventDefault();
                opts.docLeave.call(this, e);
                return false;
            }

            function docEnter(e) {
                clearTimeout(doc_leave_timer);
                e.preventDefault();
                opts.docEnter.call(this, e);
                return false;
            }

            function docOver(e) {
                clearTimeout(doc_leave_timer);
                e.preventDefault();
                opts.docOver.call(this, e);
                return false;
            }

            function docLeave(e) {
                doc_leave_timer = setTimeout((function (_this) {
                    return function () {
                        opts.docLeave.call(_this, e);
                    };
                })(this), 200);
            }

            return this;
        };

        function empty() { }

        try {
            if (XMLHttpRequest.prototype.sendAsBinary) {
                return;
            }
            XMLHttpRequest.prototype.sendAsBinary = function (datastr) {
                function byteValue(x) {
                    return x.charCodeAt(0) & 0xff;
                }
                var ords = Array.prototype.map.call(datastr, byteValue);
                var ui8a = new Uint8Array(ords);

                // Not pretty: Chrome 22 deprecated sending ArrayBuffer, moving instead
                // to sending ArrayBufferView.  Sadly, no proper way to detect this
                // functionality has been discovered.  Happily, Chrome 22 also introduced
                // the base ArrayBufferView class, not present in Chrome 21.
                if ('ArrayBufferView' in window)
                    this.send(ui8a);
                else
                    this.send(ui8a.buffer);
            };
        } catch (e) { }

    })(jQuery);

    window.dragOnUploadDialog = function (controller, method, area) {
        var companyId = GetCompanyId();
        $("#upload-dialog-drop-section").filedrop({
            fallback_id: 'btnUpload',
            fallback_dropzoneClick: true,
            url: Router.action(controller, method, { area: area, CompanyId: companyId }),
            allowedfileextensions: ['.xlsx'],
            paramname: 'fileData',
            maxfiles: 1,
            maxfilesize: 3,
            dragOver: function () {
                $('#upload-dialog-drop-section').addClass('drop-active');
            },
            dragLeave: function () {
                $('#upload-dialog-drop-section').removeClass('drop-active');
            },
            drop: function () {
                $('#upload-dialog-drop-section').removeClass('drop-active');
                bootbox.hideAll();
                loadingDialog(".body-overlay", 500, 2000, 1, "Uploading the file", "Please wait...", null, null, null, function (callback) { });
            },
            uploadFinished: function (i, file, response, time) {
                if (response.Ok == true) {
                    let message = "The analysis has been created successfully!";
                    if (response && response.Message) {
                        message = response.Message;
                        if (response.NewCompanyId) {
                            companyId = response.NewCompanyId;
                        }
                    }
                    $(".body-overlay").hide();
                    messageDialog('Success!', message, 200, 200, () => {
                        loadingDialog(".body-overlay", 500, 2000, 1, "Navigating to the analysis", "Please wait...", null, null, null, function (callback) { });
                        location = "/Corp/l/" + companyId;
                    });
                }
            },
            afterAll: function (e) {

            },
            error: function (err, file) {
                console.log(err);
                let errorMessage = "Creating the analysis has failed!";
                if (err && err.responseJSON && err.responseJSON.Error) {
                    errorMessage = err.responseJSON.Error;
                }
                $(".body-overlay").hide();
                console.log(GetCompanyId());
                messageDialog('Error', errorMessage, 200, 200, () => { bootbox.hideAll(); });
            },
        })
    };

    $(function () {

        // Frank: We should have a check here wrt if the User has accecc to ad mote companies ... in case the check on the UserArea is not good enough

        var companyId;
        $("#user-area-drop-section").filedrop({
            fallback_id: 'btnUpload',
            fallback_dropzoneClick: true,
            url: Router.action("Portfolio", "CreateCompanyFromExcelDragAndDrop", { area: "Corp" }),
            allowedfileextensions: ['.xlsx'],
            paramname: 'fileData',
            maxfiles: 1,
            maxfilesize: 3,
            dragOver: function () {
                $('#upload-from-excel').addClass('drop-active');
            },
            dragLeave: function () {
                $('#upload-from-excel').removeClass('drop-active');
            },
            drop: function () {
                $('#upload-from-excel').removeClass('drop-active');
                loadingDialog(".body-overlay", 500, 2000, 1, "Uploading the file", "Please wait...", null, null, null, function (callback) { });
            },
            uploadFinished: function (i, file, response, time) {
                let message = "The analysis has been created successfully!";

                if (response && response.Message) {
                    message = response.Message;
                    if (response.NewCompanyId) {
                        companyId = response.NewCompanyId;
                    }
                }
                $(".body-overlay").hide();
                messageDialog('Success!', message, 200, 200, () => {
                    loadingDialog(".body-overlay", 500, 2000, 1, "Navigating to the analysis", "Please wait...", null, null, null, function (callback) { });
                    location = "/Corp/l/" + companyId;
                });
            },
            afterAll: function (e) {

            },
            error: function (err, file) {
                let errorMessage = "Creating the analysis has failed!";
                if (err && err.responseJSON && err.responseJSON.Error) {
                    errorMessage = err.responseJSON.Error;
                }
                $(".body-overlay").hide();
                messageDialog('Error', errorMessage, 200, 200, () => { bootbox.hideAll(); });
            },
        })
    })

}

export function fixInputs() {
    $(".text-number").each(function () {
        var floatval = parseFloat($(this).val());
        if (isNaN(floatval)) floatval = 0;
        if (floatval == 0) {
            $(this).val("");
        } else {
            $(this).val(floatval);
        }
    });

    // PS! Also: 'document.arrive' further below


    $(".text-percent").each(function () {
        var floatval = parseFloat($(this).val());
        if (isNaN(floatval)) return;
        if (floatval > 100) {
            floatval = 100.0;
        }
        if (floatval < -100) {
            floatval = -100.0;
        }
        $(this).val(floatval + "%");
    });

    // Separate $(".text-percent"): Allow to be above 100%
    $(".text-percent-over100").each(function () {
        var floatval = parseFloat($(this).val());
        if (isNaN(floatval)) return;
        if (floatval < -100) {
            floatval = -100.0;
        }
        $(this).val(floatval + "%");
    });
    // "blur" makes so that the % is added immediately, do not need to save first
    $("#master-body-content").on("blur", ".text-percent-over100", function () {    
        var floatval = parseFloat($(this).val());
        if (isNaN(floatval)) return;
        if (floatval < -100) {
            floatval = -100.0;
        }
        $(this).val(floatval + "%");
    });

    // Separate $(".text-percent"): Allow to be above 100%, but not less than 0%
    $(".text-percent-over100-min0").each(function () {
        var floatval = parseFloat($(this).val());
        if (isNaN(floatval)) return;
        if (floatval < 0) {
            floatval = 0.0;
        }
        $(this).val(floatval + "%");
    });

    // Separate $(".text-percent"): Allow to be max 100%, but not less than 0%
    $(".text-percent-max100").each(function () {
        var floatval = parseFloat($(this).val());
        if (isNaN(floatval)) return;
        if (floatval > 100) {
            floatval = 100;
        }
        $(this).val(floatval + "%");
    });

   


    // Separate $(".text-percent"): Allow to be max 100%, but not less than 0%
    //$(".text-percent-max1000-min-2400").each(function () {
    //    var floatval = parseFloat($(this).val());
    //    if (isNaN(floatval)) return;
    //    if (floatval > 1000) {
    //        floatval = 1000;
    //    }
    //    if (floatval < -2400) {
    //        floatval = -2400;
    //    }
    //    $(this).val(floatval + "%");
    //});




    document.arrive('.text-number', function() {
        var floatval = parseFloat($(this).val());
        if (isNaN(floatval)) floatval = 0;
        if (floatval == 0) {
            $(this).val('');
        } else {
            $(this).val(floatval);
        }
    });
    // 3 alternative ways to input: 1) As depreciation percentage, 2) Absolute negative numbers, 3) Linear depreciation
    $(".text-percent-depreciation").each(function () {
        var floatval = parseFloat($(this).val());
        if (isNaN(floatval)) {
            return;
        }   
        // Below does not work...why not?
        if(floatval > 0 && floatval<100){
            $(this).val(floatval + "%");        // Only % if alternative 1, input as percentages..            
        } else if(floatval >= 100){
            $(this).val(floatval + "y");        // Only % if alternative 1, input as percentages..            
        } else {
            $(this).val(floatval);
        }
    });
    document.arrive('.text-percent-depreciation', function(record) {

        var floatval = parseFloat($(this).val());
        if (isNaN(floatval)) {
            return;
        } 
        // Below does not work...why not?
        if(floatval > 0 && floatval<100){
            $(this).val(floatval + "%");        // Only % if alternative 1, input as percentages..            
        } else if(floatval >= 100){
            $(this).val(floatval + "y");        // Only % if alternative 1, input as percentages..            
        } else {
            $(this).val(floatval);
        }
    });


    $(".text-percent-tax").each(function () {
        var floatval = parseFloat($(this).val());
        if (isNaN(floatval)) {
            return;
        }   
        // Below does not work...why not?
        if(floatval >= 0){
            $(this).val(floatval + "%");        // Only % if alternative 1, input as percentages..            
        } else {
            $(this).val(floatval);
        }
    });
    document.arrive('.text-percent-tax', function(record) {
        var floatval = parseFloat($(this).val());
        if (isNaN(floatval)) {
            return;
        } 
        if(floatval >= 0){
            $(this).val(floatval + "%");        // Only % if alternative 1, input as percentages..            
        } else {
            $(this).val(floatval);
        }
    });




     
    $(".text-credit-SalesCogs").each(function () {
        // Calculation needs e.g. "-100", "-200" etc... 1 period, 2 periods...
        var floatval = parseFloat($(this).val());   
        if (isNaN(floatval)) return;
        if (floatval <0) {
            floatval = 0;
        }  
        if(floatval > 0){
            if(floatval == 1){
                $(this).val(floatval + " period");
            }
            else{
                $(this).val(floatval + " periods");
            }
        }
        else{
            $(this).val(floatval);
        }        
    });
    document.arrive('.text-credit-SalesCogs', function(record) {
        // Calculation needs e.g. "-100", "-200" etc... 1 period, 2 periods...
        var floatval = parseFloat($(this).val());   
        if (isNaN(floatval)) return;
        if (floatval <0) {
            floatval = 0;
        }  
        if(floatval > 0){
            if(floatval == 1){
                $(this).val(floatval + " period");
            }
            else{
                $(this).val(floatval + " periods");
            }
        }
        else{
            $(this).val(floatval);
        }        
    });




    document.arrive('.text-percent', function () {
        var floatval = parseFloat($(this).val());
        if (isNaN(floatval)) return;
        if (floatval > 100) {
            floatval = 100.0;
        }
        if (floatval < -100) {
            floatval = -100.0;
        }
        $(this).val(floatval + '%');
    });
    document.arrive('.text-percent-over100', function () {
        var floatval = parseFloat($(this).val());
        if (isNaN(floatval)) return;
        if (floatval < -100) {
            floatval = -100.0;
        }
        $(this).val(floatval + '%');
    });

    // Separate $('.text-percent'): Allow to be above 100%, but not less than 0%
    document.arrive('.text-percent-over100-min0', function () {
        var floatval = parseFloat($(this).val());
        if (isNaN(floatval)) return;
        if (floatval < 0) {
            floatval = 0.0;
        }
        $(this).val(floatval + '%');
    });

    // Separate $('.text-percent'): Allow to be max 100%, but not less than 0%
    document.arrive('.text-percent-max100', function () {
        var floatval = parseFloat($(this).val());
        if (isNaN(floatval)) return;
        if (floatval > 100) {
            floatval = 100;
        }
        $(this).val(floatval + '%');
    });
    //document.arrive('.text-percent-max1000-min-2400', function () {
    //    var floatval = parseFloat($(this).val());
    //    if (isNaN(floatval)) return;
    //    if (floatval > 1000) {
    //        floatval = 1000;
    //    }
    //    if (floatval < -2400) {
    //        floatval = -2400;
    //    }
    //    $(this).val(floatval + '%');
    //});

    $("body").on("change", "#UserSettings_Id", function () {

        // Bug fix: On "Sharing and copy settings" pop-up dialog box when New is selected for User, then "Remove user" link is still shown.
        if ($("#UserSettings_Id").val() === "-1") {
            $("#private-sharing-delete-user").hide();
        }
        else {
            $("#private-sharing-delete-user").show();
        }

        // Part of the bug fix: Company can be shared to the same e-mail multiple times.
        // Remove notification.
        $("#AlreadyShared").remove();
        $(".private-share-user-selected").css('margin-bottom', '15px');
    });
}